import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonService } from '@services/app.common.service';


@Injectable()
export class CustomTranslateLoader implements TranslateLoader {
  contentHeader = new HttpHeaders({ 'Content-Type': 'application/json', responseType: 'text', 'Access-Control-Allow-Origin': '*' });
  public _baseUrl;
  public storageKey: string = "";
  public gateWayUrl: string="";
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string, public common: CommonService) {
    this._baseUrl = baseUrl;
  }
  getTranslation(lang: string): Observable<any> {

    let override = false;
    let isJTGO = false;
    let overridePrefix = '';
    try {

      const setting = JSON.parse(document.getElementById('setting-container')?.getAttribute('data-settings')??"");
      this.storageKey = setting.StorageKey;
      this.gateWayUrl = setting.GatewayUrl;
      const clientSetting = setting.ClientSetting;
      isJTGO = setting.ClientSetting.IsJTGO;
      if (clientSetting != null && clientSetting.LanguageOverridePrefix != '') {
        overridePrefix = clientSetting.LanguageOverridePrefix;
        override = true;
      }
    } catch (e) {

    }



    if (lang == null || lang == '' || lang == undefined) {
      lang = 'en';
    }

    const languageStorageKey = this.storageKey + lang;


    const apiAddress = this.gateWayUrl + 'Translation/GetTranslationFile' + '?language=' + lang;
    let translation:any = null;
    if (environment.production) {
      translation = null;
    }// this.common.JsonParseData(localStorage.getItem(lang));

    translation = null; // this.common.JsonParseData(localStorage.getItem(lang));
    // try {
    //  if (translation != null && typeof translation == "string") {
    //    translation = this.common.JsonParseData(translation)
    //    localStorage.setItem(lang, JSON.stringify(translation));
    //  }
    // } catch (e) {
    // }


    if (translation == null) {

      return new Observable(observer => {

        this.http.get('assets/i18n/' + lang + '.json', { headers: this.contentHeader }).subscribe((res: any) => {

          if (isJTGO) {

            this.http.get('assets/i18n/' + lang + '_' + 'jtgo.json', { headers: this.contentHeader }).subscribe((innerRes: any) => {

              let data = {};
              data = this.deepMerge(res, innerRes);
              sessionStorage.setItem(languageStorageKey, JSON.stringify(data));
              observer.next(data);
              observer.complete();

              if (override) {

                this.http.get('assets/i18n/' + lang + '_' + overridePrefix + '.json', { headers: this.contentHeader }).subscribe((innerRes: any) => {
                  let data = {};
                  data = this.deepMerge(res, innerRes);
                  sessionStorage.setItem(languageStorageKey, JSON.stringify(data));
                  observer.next(data);
                  observer.complete();
                },
                  error => {

                    console.log(error);
                  }
                );
                }

            },
              error => {

                console.log(error);
              }
            );
          } else if (override) {

            this.http.get('assets/i18n/' + lang + '_' + overridePrefix + '.json', { headers: this.contentHeader }).subscribe((innerRes: any) => {


              let data = {};
              // Object.assign(data, res, innerRes)
              data = this.deepMerge(res, innerRes);
              sessionStorage.setItem(languageStorageKey, JSON.stringify(data));
              observer.next(data);
              observer.complete();
            },
              error => {

                console.log(error);
              }
            );
            } else {
            sessionStorage.setItem(languageStorageKey, JSON.stringify(res));
            observer.next(res);

            observer.complete();
          }
        },
          error => {
            console.log(error);
          }
        );
      });
    } else {
      return new Observable(observer => {
        observer.next(translation);
        observer.complete();
      },
      );
    }
  }
 
  public deepMerge(target: any, source: any) {
    if (typeof target !== 'object' || typeof source !== 'object') { return false; } // target or source or both ain't objects, merging doesn't make sense
    for (const prop in source) {
      if (!source.hasOwnProperty(prop)) { continue; } // take into consideration only object's own properties.
      if (prop in target) { // handling merging of two properties with equal names
        if (typeof target[prop] !== 'object') {
          target[prop] = source[prop];
        } else {
          if (typeof source[prop] !== 'object') {
            target[prop] = source[prop];
          } else {
            if (target[prop].concat && source[prop].concat) { // two arrays get concatenated
              target[prop] = target[prop].concat(source[prop]);
            } else { // two objects get merged recursively
              target[prop] = this.deepMerge(target[prop], source[prop]);
            }
          }
        }
      } else { // new properties get added to target
        target[prop] = source[prop];
      }
    }
    return target;
  }

}
